import React from "react";
import { Link } from "react-router-dom";
import './Navbar.css';

const Navbar = () => {
  return (
    <div className="navbar-wrapper">
       <div className="container">
    <div className="container navbar-container">
      <div className="navbar-section navbar-left">
        
        <Link to="/">
          <img src="/kcl-logo.svg" alt="Logo" className="logo" />
        </Link>

        <Link to="/about" className="nav-link">Study</Link>
        <Link to="/contact" className="nav-link">Student Services</Link>
        <Link to="/contact" className="nav-link">Research & Innovation</Link>
        <Link to="/contact" className="nav-link">Our Faculties</Link>
      </div>

      <div className="navbar-section navbar-right">
        <Link to="/contact" className="nav-link">Student</Link>
        <Link to="/contact" className="nav-link">Staff</Link>
        <Link to="/contact" className="nav-link">Alumni</Link>
      </div>
      </div>

    </div>
    </div>
  );
};

export default Navbar;
